(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"));
	else if(typeof define === 'function' && define.amd)
		define(["react"], factory);
	else if(typeof exports === 'object')
		exports["fui"] = factory(require("react"));
	else
		root["fui"] = factory(root["react"]);
})(this, (__WEBPACK_EXTERNAL_MODULE__39155__) => {
return /******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 13394:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
var __webpack_unused_export__;
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var f=__webpack_require__(39155),k=Symbol.for("react.element"),l=Symbol.for("react.fragment"),m=Object.prototype.hasOwnProperty,n=f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,p={key:!0,ref:!0,__self:!0,__source:!0};
function q(c,a,g){var b,d={},e=null,h=null;void 0!==g&&(e=""+g);void 0!==a.key&&(e=""+a.key);void 0!==a.ref&&(h=a.ref);for(b in a)m.call(a,b)&&!p.hasOwnProperty(b)&&(d[b]=a[b]);if(c&&c.defaultProps)for(b in a=c.defaultProps,a)void 0===d[b]&&(d[b]=a[b]);return{$$typeof:k,type:c,key:e,ref:h,props:d,_owner:n.current}}__webpack_unused_export__=l;exports.jsx=q;__webpack_unused_export__=q;


/***/ }),

/***/ 39155:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__39155__;

/***/ }),

/***/ 64922:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


if (true) {
  module.exports = __webpack_require__(13394);
} else {}


/***/ }),

/***/ 69122:
/***/ ((module, exports) => {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = '';

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (arg) {
				classes = appendClass(classes, parseValue(arg));
			}
		}

		return classes;
	}

	function parseValue (arg) {
		if (typeof arg === 'string' || typeof arg === 'number') {
			return arg;
		}

		if (typeof arg !== 'object') {
			return '';
		}

		if (Array.isArray(arg)) {
			return classNames.apply(null, arg);
		}

		if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
			return arg.toString();
		}

		var classes = '';

		for (var key in arg) {
			if (hasOwn.call(arg, key) && arg[key]) {
				classes = appendClass(classes, key);
			}
		}

		return classes;
	}

	function appendClass (value, newClass) {
		if (!newClass) {
			return value;
		}
	
		if (value) {
			return value + ' ' + newClass;
		}
	
		return value + newClass;
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ 81301:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"firmColor":"#5d3b84","secondaryColor":"silver","successColor":"#4ab675","i":"src-components-Icon-styles_i","smallIcon":"src-components-Icon-styles_smallIcon","disabled":"src-components-Icon-styles_disabled","greyIcon":"src-components-Icon-styles_greyIcon"});

/***/ }),

/***/ 87083:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ Icon_BaseIcon)
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(64922);
// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(39155);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(69122);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/components/Icon/styles.scss
var styles = __webpack_require__(81301);
;// ./src/components/Icon/BaseIcon/BaseIcon.tsx
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};




function BaseIcon(_a) {
    var { icon, src, className, isDisabled = false, onClick = () => null, onMouseEnter = () => null, onMouseLeave = () => null, isSmall = false, isGrey = false, style } = _a, restProps = __rest(_a, ["icon", "src", "className", "isDisabled", "onClick", "onMouseEnter", "onMouseLeave", "isSmall", "isGrey", "style"]);
    const [iconHtml, setIconHtml] = (0,external_react_.useState)(null);
    const isMounted = (0,external_react_.useRef)(false);
    (0,external_react_.useEffect)(() => {
        const controller = new AbortController();
        isMounted.current = true;
        getIconHtml(controller);
        return () => {
            isMounted.current = false;
            controller === null || controller === void 0 ? void 0 : controller.abort();
        };
    }, [icon, src]);
    const getIconHtml = (controller) => __awaiter(this, void 0, void 0, function* () {
        if (src) {
            let iconResponse = yield fetch(src, {
                signal: controller.signal,
            });
            // @ts-ignore
            setIconHtml(yield iconResponse.text());
            // @ts-ignore
            controller = null;
            return;
        }
        let iconHtml = null;
        if (icon) {
            iconHtml = icon;
        }
        // @ts-ignore
        isMounted.current && setIconHtml(iconHtml);
    });
    return ((0,jsx_runtime.jsx)("i", { "data-test": restProps['data-test'], className: classnames_default()(styles/* default */.A.i, className, {
            [styles/* default */.A.disabled]: isDisabled,
            [styles/* default */.A.smallIcon]: isSmall,
            [styles/* default */.A.greyIcon]: isGrey,
        }), 
        // @ts-ignore
        dangerouslySetInnerHTML: { __html: iconHtml }, onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, style: style }));
}
/* harmony default export */ const BaseIcon_BaseIcon = (BaseIcon);

;// ./src/components/Icon/BaseIcon/index.ts

/* harmony default export */ const Icon_BaseIcon = (BaseIcon_BaseIcon);


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry needs to be wrapped in an IIFE because it needs to be in strict mode.
(() => {
"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ Icon_IconAngelList)
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(64922);
// EXTERNAL MODULE: ./src/components/Icon/BaseIcon/index.ts + 1 modules
var BaseIcon = __webpack_require__(87083);
;// ./src/components/Icon/IconAngelList/angel-list.inline.svg?raw
/* harmony default export */ const angel_list_inlineraw = ("<svg focusable=\"false\" width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M11.2207 6.82436C11.8718 6.94882 12.3308 7.22717 12.5985 7.65942C12.8662 8.09167 13 8.77283 13 9.70345C13 11.5497 12.4521 13.0604 11.3567 14.2365C10.2608 15.4122 8.85998 16 7.15308 16C6.48063 16 5.82792 15.8772 5.19496 15.6316C4.562 15.3861 4.0179 15.0438 3.5621 14.6043C3.04159 14.121 2.65106 13.6098 2.39053 13.0715C2.12999 12.5331 2 11.9819 2 11.4175C2 10.7874 2.13383 10.3007 2.4015 9.95625C2.66916 9.61178 3.09205 9.37787 3.67071 9.25287C3.5621 8.99618 3.48257 8.78006 3.43211 8.60449C3.38165 8.42892 3.35642 8.29335 3.35642 8.19779C3.35642 7.86833 3.5281 7.53108 3.87145 7.18661C4.21481 6.84214 4.53842 6.66991 4.84228 6.66991C4.97228 6.66991 5.10995 6.6938 5.25475 6.74158C5.39955 6.78936 5.56574 6.8677 5.75388 6.97771C5.19661 5.38093 4.79182 4.14807 4.53897 3.28023C4.28556 2.41239 4.15941 1.81346 4.15941 1.48344C4.15941 1.02952 4.27514 0.66838 4.50661 0.401139C4.73807 0.133898 5.05236 0 5.45056 0C6.13014 0 6.99127 1.53844 8.03231 4.61532C8.21276 5.14258 8.35044 5.54928 8.44478 5.83485C8.52431 5.60817 8.6362 5.28537 8.781 4.86756C9.82259 1.82013 10.7188 0.296132 11.4714 0.296132C11.8399 0.296132 12.1345 0.422251 12.3555 0.675047C12.576 0.927842 12.6863 1.26675 12.6863 1.69178C12.6863 2.01403 12.565 2.60407 12.3226 3.4608C12.0791 4.31919 11.7127 5.43982 11.2207 6.82436ZM3.4535 11.308C3.55497 11.4325 3.69594 11.6158 3.87639 11.8575C4.35358 12.5242 4.79457 12.8576 5.1999 12.8576C5.33702 12.8576 5.46043 12.8137 5.56849 12.7259C5.67709 12.6381 5.73139 12.5464 5.73139 12.4514C5.73139 12.3414 5.65899 12.1586 5.51419 11.9019C5.36938 11.6458 5.17083 11.3563 4.91743 11.0341C4.62837 10.6607 4.38758 10.3874 4.19616 10.2152C4.00474 10.0429 3.85061 9.9568 3.73488 9.9568C3.48148 9.9568 3.24837 10.094 3.035 10.3691C2.82164 10.6435 2.71523 10.968 2.71523 11.3413C2.71523 11.6419 2.78928 11.9769 2.93737 12.347C3.08546 12.717 3.30102 13.0887 3.58295 13.4626C4.00967 14.0415 4.53897 14.486 5.17248 14.7977C5.80544 15.1094 6.50476 15.265 7.27155 15.265C8.68172 15.265 9.86263 14.7321 10.8137 13.6665C11.7648 12.6003 12.2403 11.2652 12.2403 9.66123C12.2403 9.17064 12.2041 8.78061 12.1317 8.49115C12.0593 8.20168 11.9403 7.99111 11.7736 7.85944C11.4768 7.61053 10.9004 7.38718 10.0431 7.18939C9.18634 6.9916 8.2912 6.8927 7.35821 6.8927C7.09768 6.8927 6.91339 6.93659 6.80479 7.02438C6.69618 7.11216 6.64188 7.26273 6.64188 7.47496C6.64188 7.97333 6.91668 8.33391 7.46627 8.55726C8.01586 8.78061 8.90551 8.89229 10.1347 8.89229H10.5795C10.681 8.89229 10.7622 8.93062 10.8236 9.00785C10.885 9.08452 10.9267 9.20008 10.9481 9.35398C10.8252 9.47121 10.5718 9.60511 10.1884 9.75512C9.80504 9.90513 9.51214 10.0535 9.30975 10.2002C8.87589 10.5224 8.52705 10.9052 8.26268 11.3486C7.9983 11.7919 7.86667 12.2114 7.86667 12.607C7.86667 12.8487 7.92261 13.1398 8.03505 13.4804C8.14695 13.821 8.20344 14.0315 8.20344 14.1121V14.1888L8.1815 14.2877C7.86338 14.2654 7.61217 14.0771 7.42732 13.7215C7.24303 13.3665 7.15088 12.892 7.15088 12.2986V12.1997C7.09274 12.2509 7.0368 12.2875 6.9825 12.3097C6.9282 12.332 6.86841 12.3425 6.80369 12.3425C6.73842 12.3425 6.67699 12.337 6.6194 12.3259C6.56126 12.3147 6.49653 12.2986 6.42413 12.2764C6.44607 12.357 6.46198 12.4359 6.47295 12.5125C6.48392 12.5892 6.4894 12.6498 6.4894 12.6937C6.4894 12.9648 6.38464 13.1976 6.17457 13.3915C5.9645 13.5854 5.71493 13.6826 5.42588 13.6826C4.97008 13.6826 4.50716 13.4576 4.0371 13.007C3.56704 12.5564 3.33174 12.1153 3.33174 11.683C3.33174 11.6025 3.34051 11.5308 3.35861 11.4686C3.37891 11.4052 3.41017 11.3519 3.4535 11.308ZM6.7077 11.5719C6.83057 11.5719 6.94246 11.5152 7.04393 11.4013C7.1454 11.288 7.19586 11.1652 7.19586 11.033C7.19586 10.8941 7.09658 10.5696 6.89748 10.0607C6.69838 9.55178 6.45101 9.05174 6.15428 8.5606C5.93707 8.19446 5.72371 7.91777 5.51419 7.73109C5.30411 7.54441 5.10556 7.45107 4.91743 7.45107C4.76549 7.45107 4.59766 7.5483 4.41281 7.7422C4.22852 7.93611 4.13637 8.11779 4.13637 8.28613C4.13637 8.4617 4.22688 8.72561 4.40733 9.0773C4.58778 9.42899 4.83022 9.80235 5.13408 10.1979C5.45221 10.6302 5.75223 10.9669 6.03471 11.2091C6.31718 11.4508 6.54151 11.5719 6.7077 11.5719ZM7.77068 6.26432L6.5991 2.83575C6.29524 1.96403 6.06048 1.39454 5.89374 1.12674C5.727 0.859504 5.54655 0.725606 5.35128 0.725606C5.19935 0.725606 5.07649 0.784499 4.9827 0.901174C4.8889 1.0184 4.84174 1.17564 4.84174 1.37343C4.84174 1.71067 4.96789 2.29627 5.22129 3.13189C5.47415 3.96694 5.85425 5.06202 6.36051 6.41767C6.40384 6.33711 6.46527 6.28044 6.5448 6.2471C6.62433 6.21432 6.73293 6.19765 6.87006 6.19765C6.91339 6.19765 7.00005 6.20154 7.13059 6.20876C7.26113 6.21654 7.4745 6.23488 7.77068 6.26432ZM8.99656 9.59344C8.68557 9.579 8.39048 9.54566 8.11239 9.49455C7.83376 9.44343 7.56829 9.3701 7.31488 9.27453C7.43062 9.509 7.53373 9.74346 7.62423 9.97792C7.71473 10.2124 7.78878 10.4435 7.84637 10.6702C8.0197 10.4502 8.20234 10.2507 8.39432 10.0713C8.58629 9.89235 8.78704 9.7329 8.99656 9.59344ZM10.4396 6.63768C10.924 5.30426 11.3019 4.20363 11.5734 3.33579C11.8443 2.46795 11.9804 1.93458 11.9804 1.73679C11.9804 1.52455 11.9354 1.35954 11.8449 1.24231C11.7544 1.12508 11.6293 1.06674 11.4708 1.06674C11.2684 1.06674 11.0622 1.23731 10.8527 1.57789C10.6426 1.91847 10.4117 2.46628 10.1583 3.22078L9.07335 6.39656L10.4396 6.63768Z\"/>\n</svg>\n");
;// ./src/components/Icon/IconAngelList/IconAngelList.tsx



const IconAngelList = (props) => ((0,jsx_runtime.jsx)(BaseIcon["default"], Object.assign({ icon: angel_list_inlineraw }, props)));
/* harmony default export */ const IconAngelList_IconAngelList = (IconAngelList);

;// ./src/components/Icon/IconAngelList/index.ts

/* harmony default export */ const Icon_IconAngelList = (IconAngelList_IconAngelList);

})();

/******/ 	return __webpack_exports__;
/******/ })()
;
});
//# sourceMappingURL=index.js.map